import { useDebounceFn } from '@vueuse/core'
import { isAgentBot } from '~/shared/utils/isAgentBot'

export default defineNuxtRouteMiddleware(async (to) => {
  const path = to.path.startsWith('/') ? to.path.slice(1) : to.path
  const utmStore = useUTMStore()
  const { setUtmState } = utmStore

  // Only run on client side
  if (import.meta.client) {
    // Get headers from the browser
    const referer = document.referrer || ''
    const userAgent = navigator.userAgent

    const isBotRequest = isAgentBot(userAgent)

    if (isBotRequest) {
      // Skip processing for known bot user agents
      return
    }

    try {
      const newContent = await $fetch('/intl-api/utm-slug', {
        method: 'POST',
        body: {
          path: path
        },
        headers: {
          referer: referer
        }
      })
      setUtmState(newContent || {})

      // Find utm_medium for client side navigation, need to non-blocking call
      useDebounceFn(async () => {
        try {
          const utmMedium = await $fetch<{
            utm_medium?: string
          }>('/intl-api/utm-medium', {
            method: 'POST',
            body: {
              path: path
            }
          })

          if (utmMedium?.utm_medium) {
            setUtmState({
              ...utmStore.utmState,
              utm_medium: utmMedium.utm_medium
            })
          }
        } catch (error) {
          console.warn('Failed to fetch UTM medium:', error)
        }
      }, 300)()
    } catch (error) {
      console.warn('Failed to fetch UTM data:', error)
    }
  }
})
